import React from "react";
import { FiCheck, FiPackage, FiRefreshCw, FiTruck } from "react-icons/fi";
import { BsCashCoin } from "react-icons/bs";

import {
  OrderSummary,
  SummaryRow,
  FreeShippingModule,
  FreeShippingText,
  ProgressTrack,
  ProgressFill,
  TrustRow,
} from "../CartPage.styles";
import { formatPrice } from "../../../../utils/utils";
import { formatShipping, getCountryConfig } from "../helpers";

/*
 * Pregled korpe (v2 s.9.3): redovi direktno u kartici, free-shipping
 * progress modul, "Cene uključuju PDV", trust red ispod CTA (u parentu).
 */
export default function CartOrderSummary({
  totals,
  country,
  hasItems,
  showShipping = true,
  paymentRow = false, // checkout: red "Plaćanje: Pouzećem" (v2 s.13.1)
}) {
  if (!hasItems) return null;
  const cfg = getCountryConfig(country);

  const threshold = cfg.freeShippingThreshold;
  const reachedFreeShipping =
    threshold && totals.subtotal >= threshold;
  // da li kupac kuriru plaća i poštarinu (pored iznosa za proizvode)
  const placaPostarinu = showShipping ? totals.shipping > 0 : !reachedFreeShipping;

  return (
    <>
      <OrderSummary>
        <SummaryRow>
          <span className="label">Međuzbir</span>
          <span className="value">{formatPrice(totals.subtotal)}</span>
        </SummaryRow>

        {showShipping && totals.hasMultipleShipments ? (
          <>
            <SummaryRow
              style={{
                fontSize: "0.85rem",
                color: "var(--brand)",
                fontWeight: 600,
                marginTop: "0.4rem",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.35rem",
                }}
              >
                <FiPackage size={14} />
                Šalje se u {totals.totalShipments} paketa
              </span>
              <span />
            </SummaryRow>

            {totals.centralShippingCost >= 0 &&
              totals.centralShippingSubtotal > 0 && (
                <SummaryRow
                  style={{ fontSize: "0.78rem", paddingLeft: "1.4rem" }}
                >
                  <span className="label">Centralna dostava:</span>
                  <span className="value">
                    {formatShipping(totals.centralShippingCost, country)}
                  </span>
                </SummaryRow>
              )}

            {totals.bandGroups.map((bandGroup) => (
              <SummaryRow
                key={bandGroup.sellerKey}
                style={{ fontSize: "0.78rem", paddingLeft: "1.4rem" }}
              >
                <span className="label">{bandGroup.sellerName}:</span>
                <span className="value">
                  {formatShipping(bandGroup.shippingCost, country)}
                </span>
              </SummaryRow>
            ))}

            <SummaryRow>
              <span className="label">Ukupna poštarina</span>
              <span className="value">
                {formatShipping(totals.shipping, country)}
              </span>
            </SummaryRow>
          </>
        ) : showShipping ? (
          <SummaryRow>
            <span className="label">Poštarina ({cfg.name})</span>
            <span className="value">
              {formatShipping(totals.shipping, country)}
            </span>
          </SummaryRow>
        ) : (
          /* korak korpe: država se bira tek pri plaćanju, prikaz za podrazumevanu */
          <SummaryRow>
            <span className="label">Poštarina</span>
            <span
              className="value"
              style={
                reachedFreeShipping
                  ? { color: "var(--success)" }
                  : { color: "var(--text-muted)", fontWeight: 400 }
              }
            >
              {reachedFreeShipping
                ? "Besplatna"
                : formatShipping(cfg.deliveryPrice, country)}
            </span>
          </SummaryRow>
        )}

        {paymentRow && (
          <SummaryRow>
            <span className="label">Plaćanje</span>
            <span className="value" style={{ fontWeight: 500 }}>
              Pouzećem
            </span>
          </SummaryRow>
        )}

        <SummaryRow className="total">
          <span className="label">Ukupno</span>
          <span className="value">{formatPrice(totals.total)}</span>
        </SummaryRow>
        {placaPostarinu && (
          <SummaryRow style={{ fontSize: "0.78rem", color: "var(--text-muted)" }}>
            <span>+ poštarina, plaćaš je kuriru po cenovniku Pošte</span>
            <span />
          </SummaryRow>
        )}
      </OrderSummary>

      {/* Free-shipping modul (v2 s.9.3), samo za države sa pragom */}
      {threshold && (
        <FreeShippingModule>
          {reachedFreeShipping ? (
            <FreeShippingText $reached>
              <FiCheck size={15} /> Besplatna dostava
            </FreeShippingText>
          ) : (
            <>
              <FreeShippingText>
                Još {formatPrice(threshold - totals.subtotal)} do besplatne
                dostave
              </FreeShippingText>
              <ProgressTrack>
                <ProgressFill
                  $percent={(totals.subtotal / threshold) * 100}
                />
              </ProgressTrack>
            </>
          )}
        </FreeShippingModule>
      )}
    </>
  );
}

/* Trust red ispod CTA dugmeta (v2 s.9.3) */
export function CartTrustRow() {
  return (
    <TrustRow>
      <span>
        <BsCashCoin size={13} /> Pouzećem
      </span>
      <span>
        <FiRefreshCw size={13} /> 30 dana povraćaj
      </span>
      <span>
        <FiTruck size={13} /> PostExpres
      </span>
    </TrustRow>
  );
}
